import React, { useCallback, useMemo } from 'react';
import ReportsHeader from 'npo/pages/ReportsBeta/ReportsHeader';

interface ContributionAddNewProps {
  count: number;
}

const ContributionAddNew: React.FC<ContributionAddNewProps> = ({ count }) => {
  const handleDonationClick = useCallback(() => { /* noop */ }, []);
  const handlePortfolioClick = useCallback(() => { /* noop */ }, []);
  const addButtons = useMemo(
    () => [
      {
        text: 'Donation',
        onClick: handleDonationClick,
      },
      {
        text: 'Portfolio',
        onClick: handlePortfolioClick,
      },
    ],
    [handleDonationClick, handlePortfolioClick],
  );

  return (
    <>
      <ReportsHeader count={count} text="Donations" onAdd={addButtons} />
    </>
  );
};

export default ContributionAddNew;
